<template><div class="settings main flex">
  <sticky-bar @back="$router.push('/s/uac')" :loading="!fleet">
    Fleet: {{ fleet ? fleet.name : 'Loading...' }}
    <small>User Access Control</small>
  </sticky-bar>
  <div class="flex-fill padded scroll">
    <Loading v-if="owner.usersLoading || loading" />
    <div v-else-if="owner.users === null">
      An error occurred. <button @click="refreshOwnerUsers">Try Again</button>
    </div>
    <div v-else-if="access === null">
      An error occurred. <button @click="refreshAccess">Try Again</button>
    </div>
    <div v-else>
      <table>
      <thead>
        <tr>
          <th>User</th>
          <th>VPN</th>
          <th>Manager</th>
          <th>Restricted</th>
          <th>Revoke</th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="a in access"
            :key="`a-${a[0]}`"
          >
          <th>{{ a[0] }}
            <template v-if="owner.users[a[0]].firstName">
              <br/>
              ({{ owner.users[a[0]].firstName }} {{ owner.users[a[0]].lastName }})
            </template></th>
          <th v-if="a[0] in eLoading" colspan="3"><Loading /></th>
          <template v-else>
            <td><label title="VPN Access"><input type="checkbox" :checked="a[2] & UAC_VPN" @click.prevent="toggleFlag(a, UAC_VPN)" /></label></td>
            <td><label title="Fleet Manager"><input type="checkbox" :checked="a[2] & UAC_MANAGER" @click.prevent="toggleFlag(a, UAC_MANAGER)" /></label></td>
            <td><label title="Restricted"><input type="checkbox" :checked="a[2] & UAC_RESTRICTED" @click.prevent="toggleFlag(a, UAC_RESTRICTED)" /></label></td>
            <th><button @click="revoke(a)">Revoke</button></th>
          </template>
        </tr>
      </tbody>
      </table>
      <Loading v-if="addLoading" />
      <div v-else class="add-user">
        <p>Add a user:
          <input type="text" v-model="filter" 
              @keydown.escape="filter=''"
            />
        </p>
        <div>
          <template v-if="filter && !filteredUsers.some(email => email.toLowerCase() === filter.toLowerCase())">
            <b>Create new user:</b>
            <span>Email: <a href="#" @click.prevent="addUser(filter, true)">{{filter}}</a></span>
          </template>
          <b v-if="filteredUsers.length">Available users:</b>
          <a v-for="email in filteredUsers"
              :key="`add-${email}`"
              href="#"
              @click.prevent="addUser(email)">
            {{email}}
            <template v-if="owner.users[email].firstName">
              ({{owner.users[email].firstName}} {{owner.users[email].lastName}})
            </template>
          </a>
        </div>
      </div>
    </div>
  </div>
</div></template>
<script>
import api from '../../../api'
import Loading from '../../Loading'
import StickyBar from '../../StickyBar'
import { mapActions } from 'vuex'
const UAC_VPN = 1, UAC_MANAGER = 2, UAC_RESTRICTED = 4
export default {
  name: 'UACFleet',
  props: ['id'],
  components: { Loading, StickyBar },
  data() {
    return {
      loading: false,
      eLoading: {},
      addLoading: false,
      access: null,
      filter: '',
      UAC_VPN,
      UAC_MANAGER,
      UAC_RESTRICTED,
    }
  },
  computed: {
    fleet() { return this.$store.getters.fleets[this.id] },
    owner() { return this.$store.state.owner },
    filteredUsers() {
      if (this.filter === '') return []
      let filter = this.filter.toLowerCase()
      let rv = []
      for (const u of this.owner.sortedUsers) {
        if (this.accessSet.has(u.email))
          continue
        if (u.email.toLowerCase().indexOf(filter) >= 0
            || (u.firstName
              && (u.firstName.toLowerCase().indexOf(filter) >= 0
                || u.lastName.toLowerCase().indexOf(filter) >= 0))) {
          rv.push(u.email)
          if (rv.length >= 10) break
        }
      }
      return rv
    },
  },
  created() {
    this.ref = null
    this.refs = {}
    this.addRef = null
    this.refreshOwnerUsers({ weak: true })
    this.refreshAccess()
  },
  methods: {
    ...mapActions(['refreshOwnerUsers']),
    async refreshAccess() {
      if (this.ref !== null) this.ref.cancel()
      let ref = this.ref = { fleetId: this.id }
      this.loading = true
      this.access = null
      this.accessSet = null
      try {
        let aa = await api.getAccess(ref)
        if (ref !== this.ref)
          return
        let accessSet = new Set()
        for (const a of aa)
          accessSet.add(a[0])
        
        this.ref = null
        this.loading = false
        this.access = aa
        this.accessSet = accessSet

      } catch(e) {
        if (ref !== this.ref)
          return
        this.ref = null
        this.loading = false
        console.error(e)
      }
    },
    async toggleFlag(a, flag) {
      const [ email, fid, oldFlags ] = a
      let flags = oldFlags ^ flag
      if (flag & flags) {
        if (flag & (UAC_VPN | UAC_MANAGER))
          flags &= ~UAC_RESTRICTED
        else if (flag & UAC_RESTRICTED)
          flags &= ~(UAC_VPN | UAC_MANAGER)
      }
      this.$set(this.eLoading, email, true)
      let ref = this.refs[email] = {
        fleetId: this.id,
        email,
        flags,
      }
      try {
        await api.setAccess(ref)
        this.$set(a, 2, flags)
      } catch(e) {
        console.error(e)
        alert('An error occurred. Please try again.')
      } finally {
        delete this.refs[email]
        this.$delete(this.eLoading, email)
      }
    },
    async revoke(a) {
      const [ email, fid, oldFlags ] = a
      this.$set(this.eLoading, email, true)
      let ref = this.refs[email] = {
        fleetId: this.id,
        email,
      }
      try {
        await api.setAccess(ref)
        await this.refreshOwnerUsers()
        await this.refreshAccess()
      } catch(e) {
        console.error(e)
        alert('An error occurred. Please try again.')
      } finally {
        delete this.refs[email]
        this.$delete(this.eLoading, email)
      }
    },
    async addUser(email, newUser) {
      if (!email) return
      this.addLoading = true
      let ref = this.addRef = {
        fleetId: this.id,
        email,
        flags: 0,
        newUser,
      }
      try {
        await api.setAccess(ref)
        await this.refreshOwnerUsers()
        await this.refreshAccess()
      } catch(e) {
        console.error(e)
        alert('An error occurred. Please try again.')
      } finally {
        this.filter = ''
        this.addRef = null
        this.addLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
  th, td {
    border: 1px solid #000;
  }
  th {
    padding: 5px 10px;
  }
  td {
    position: relative;
  }
  .red { color: #c00; }
  label {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
.add-user {
  b { display: block; }
  div > a, div > span {
    display: block;
    padding: 0 0 5px 20px;
  }
}
</style>
